import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  ElementRef,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormArray,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { Physician } from "src/app/models/physician";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import moment from "moment";
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { FieldControlService } from "src/app/forms/models/field-control.service";

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-view-appointment-patient",
  templateUrl: "./view-appointment-patient.component.html",
  styleUrls: ["./view-appointment-patient.component.css"],
  providers: [FieldControlService],
})
export class ViewAppointmentPatientComponent implements OnInit {
  @ViewChild("PDFModal", { static: true } as any) PDFModal: TemplateRef<any>;
  @ViewChild("inputFile")
  inputFile: ElementRef;
  details: any;
  isLoading: boolean = true;
  physician: Physician;
  physician_model: any = {};
  specialitiesList: any = [];
  states: any = [];
  dateFormat = Utils.DATE_FORMAT;
  aptType = Utils.APPOINTMENT_TYPE;
  aptStatus = Utils.APPOINTMENT_STATUS;
  currentDate = Utils.maxDate;
  maxSize = Utils.MAX_FILE_SIZE;
  rescheduleForm: UntypedFormGroup;
  disableSubmit: boolean = false;
  forms = {
    documentsForm: null,
  };
  timeSlots: any[];
  selectedItem: any;
  aptime: any;
  defaultDr = Utils.DEFAULTDR;
  maxDate = Utils.today;
  maxDates: any;
  documents: UntypedFormArray;
  pdfSrc: any;
  uploadedFiles: [File];
  inpersonvideo: any;
  noSlotDate: any; cur_day: any;
  aptinterval: any;
  today: Date;
  nextDay: any;
  allTimeSlots: any[];
  public loading: boolean = true;
  public workingHours = [];
  excludeDays: number[];
  miniDate = Utils.miniDate;
  constructor(
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private service: VproService,
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private formService: FieldControlService
  ) {
    this.forms.documentsForm = this._formBuilder.group({
      documents: this._formBuilder.array([]),
    });
  }

  ngOnInit() {
    /* =============== Fetch Appointment =============== */
    this.getAppointment();
    this.rescheduleForm = this._formBuilder.group({
      apdate: ["", Validators.required],
      aptime: ["", Validators.required],
    });
    // this.getPhysician();
  }

  /* =============== Get Appointment function to get appointment by Appointment ID =============== */
  getAppointment() {
    this.spinner.show();
    this.service
      .getAppointmentDetails({
        aptid: this.route.snapshot.params["aptid"],
        fields: [
          "physician_details",
          "patient_details",
          "conference_link",
          "documents",
        ],
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.details = res;
          this.isLoading = false;
          /* =============== Map Appointment Type from Constants =============== */
          if (res && res.apttype) {
            this.details.apttype = Object.keys(this.aptType).find(
              (key) => this.aptType[key] === res.apttype
            );
          }
          /* =============== Map Appointment Schedule Status from Constants =============== */
          if (res && res.schedule_stat) {
            this.details.schedule_stat = Object.keys(this.aptStatus)
              .find((key) => this.aptStatus[key] === res.schedule_stat)
              .replace("_", " ");
          }

          if (res && res.physician_details) {
            this.physician = res.physician_details;
            console.log("physician", this.physician);
          }

          if (
            this.physician &&
            this.physician.physician_qualification &&
            this.physician.physician_qualification.length
          ) {
            this.physician.qualification =
              this.physician.physician_qualification[0].qualification;
          }

          if (
            this.physician &&
            this.physician.physician_education &&
            this.physician.physician_education.length
          ) {
            this.physician_model.education = this.physician.physician_education
              .map((x) => x.degree)
              .join(", ");
            this.physician_model.university = this.physician.physician_education
              .map((x) => x.institution)
              .join(", ");
          }

          if (
            this.physician &&
            this.physician.physician_speciality &&
            this.physician.physician_speciality.length
          ) {
            this.getSpecialitiesList(); /* =============== Fetch Speciality array =============== */
          }

          if (this.physician && this.physician.state) {
            this.loadStates(); /* =============== Fetch States Array =============== */
          }
          console.log("res.followup_date values", res)
          console.log("res_online checkin", res.online_checkin)


          this.inpersonvideo = res.online_checkin



          if (res && res.followup_date) {
            let fdate = moment(res.followup_date).format("DD/MM/YYYY");
            let start = moment(fdate, "DD/MM/YYYY").toDate();
            //let start = moment(contractMoment).add(this.physician.physician_consultfee[0].followup_days, 'days').toDate();
            this.maxDates = {
              year: start.getFullYear(),
              month: start.getMonth() + 1,
              day: start.getDate(),
            };
            console.log("maxDates", this.maxDates)
          }
          // display uploaded docs
          if (res && res.documents && res.documents.length > 0) {
            this.documents = this.forms.documentsForm.get(
              "documents"
            ) as UntypedFormArray;
            res.documents.forEach((doc) => {
              this.documents.push(
                this.createDocument(
                  doc.description,
                  doc.key.split("/").pop(),
                  doc.type ? doc.type : "",
                  doc.previewUrl,
                  true
                )
              );
            });
            if (this.documents.length < 10) {
              this.documents.push(this.createDocument());
            }

            if (this.details.documents.length > 10) {
              this.disableSubmit = true;
            }
          } else {
            this.addingDocument(1);
          }
          console.log("this.physician this.physician", this.physician)
          let interval_apt = this.physician?.aptinterval ?? 0
          this.today = new Date(); // Sets today's date
          this.nextDay = new Date(this.today);
          this.nextDay.setDate(this.today.getDate() + interval_apt);
          const dateObject = new Date(this.nextDay);
          const year = dateObject.getFullYear();
          const month = dateObject.getMonth() + 1; // Months are zero-indexed, so adding 1
          const day = dateObject.getDate();
          this.aptinterval = {
            year: year,
            month: month,
            day: day,
          };
          console.log("this.aptinterval", this.aptinterval)
          this.getDefaultWorkingHours(this.physician.u_id);
          this.getAllTimeSlots();
        },
        (error) => {
          this.spinner.hide();
          this.isLoading == false;
          this.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  /* =============== Fetch and Map Specialities =============== */
  getSpecialitiesList() {
    this.spinner.show();
    this.service.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
        /* =============== Map Specialities =============== */
        let specialities = [];
        this.physician.physician_speciality.forEach((element) => {
          let sp = this.specialitiesList.find(
            (s) => s.id == element.speciality_id
          );
          specialities.push(`${sp.name} - ${element.no_of_years}Years`);
        });
        this.physician_model.speciality = specialities.join(", ");
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  /* =============== Fetch States =============== */
  loadStates() {
    this.service.getStates(1).subscribe((res) => {
      this.states = res;
      this.physician_model.location = this.states.find(
        (x) => x.id == this.physician.state
      );
      this.physician_model.location = ", " + this.physician_model.location.name;
    });
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  /* =============== Get Timeslots by Appoitnment Date =============== */
  getTimeSlots() {
    let { year, month, day } = this.rescheduleForm.value.apdate;
    this.spinner.show();
    this.service
      .getappoint({ drid: this.details.drid, date: `${year}-${month}-${day}` })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.timeSlots = res;
          if (!(res && res.length)) {
            Swal.fire({
              type: "warning",
              title: "Oops...",
              text: "No timeslots available for this day!",
            });
          }
          this.selectedItem = null;
          this.rescheduleForm.get("aptime").reset();
        },
        (error) => {
          this.spinner.hide();
          this.showToast(
            "error",
            "Something went wrong while fetching time slots. Please try again."
          );
        }
      );
  }

  /* =============== Patch selected timeslot to form control =============== */
  TimeSlotSelected(i) {
    this.selectedItem = i;
    this.rescheduleForm.patchValue({
      aptime: this.timeSlots[i]["start_time"],
    });
  }

  /* =============== Returns selected Timeslot =============== */
  isSelectedItem(i) {
    return this.selectedItem === i;
  }

  /* =============== Reschedule Appointment =============== */
  rescheduleAppointment() {
    let { year, month, day } = this.rescheduleForm.value.apdate;
    let data = {
      aptname: this.details.aptname,
      drid: this.details.drid,
      apdate: `${year}-${month}-${day}`,
      aptime: this.rescheduleForm.value.aptime,
      action: Utils.APPOINTMENT_REQUEST_TYPE.RESCHEDULE,
      pid: this.details.pid,
      updatedat: this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day,
     

    };
    console.log("year", year)
    console.log("month", month)
    console.log("day", day)
    console.log("data", data)
    // Show confirmation Message
    Swal.fire({
      title: "Reschedule Appointment?",
      text: "Your old appointment will be cancelled and a new appointment request will be generated for your appointment time. Are you sure?",
      type: "info",
      showCancelButton: true,
      buttonsStyling: true,
      confirmButtonClass: "btn btn-primary",
      confirmButtonText: "Yes",
      cancelButtonClass: "btn btn-secondary",
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        console.log("data", data)
        console.log("this.details.aid", this.details.aid)
        this.service.editSchedule(data, this.details.aid).subscribe(
          (res) => {
            this.spinner.hide();
            // Show Success Message
            Swal.fire({
              title: "Appointment has been rescheduled successfully",
              type: "success",
              showConfirmButton: false,
              timer: 2000,
            });
            // window.location.reload();
          },
          (error) => {
            this.spinner.hide();
            let message =
              error && error.error && error.error.error
                ? error.error.error
                : "Something went wrong. Please try again.";
            this.showToast("error", message);
          }
        );
      }
    });
  }

  /* =============== Cancel Appointment =============== */
  cancelAppointment() {
    let data = {
      aptname: this.details.aptname,
      drid: this.details.drid,
      action: Utils.APPOINTMENT_REQUEST_TYPE.CANCELLED,
      apdate: this.details.apdate,
      aptime: this.details.aptime,
    };
    // Show confirmation Message
    Swal.fire({
      title: "Cancel Appointment?",
      text: "Do you really want to cancel appointment?",
      type: "info",
      showCancelButton: true,
      buttonsStyling: true,
      confirmButtonClass: "btn btn-danger",
      confirmButtonText: "Yes",
      cancelButtonClass: "btn btn-secondary",
    }).then((result) => {
      // Show another confirmation Message
      if (result.value) {
        Swal.fire({
          text: "No refund will be provided if you cancel appointment just 24 hours prior to appointment. Are you sure you want to cancel appointment?",
          type: "info",
          showCancelButton: true,
          buttonsStyling: true,
          confirmButtonClass: "btn btn-danger",
          confirmButtonText: "Yes",
          cancelButtonClass: "btn btn-secondary",
        }).then((result) => {
          if (result.value) {
            this.spinner.show();
            this.service.editSchedule(data, this.details.aid).subscribe(
              (res) => {
                this.spinner.hide();
                // Show success Message
                Swal.fire({
                  title: "Appointment has been cancelled successfully",
                  type: "success",
                  showConfirmButton: false,
                  timer: 2000,
                });
                window.location.reload();
              },
              (error) => {
                this.spinner.hide();
                let message =
                  error && error.error && error.error.error
                    ? error.error.error
                    : "Something went wrong. Please try again.";
                this.showToast("error", message);
              }
            );
          }
        });
      }
    });
  }

  selectFile(event, i) {
    let {
      target: { files },
    } = event;

    console.log("event", event)
    let [file] = files;
    console.log("files", files)
    if (file) {

      console.log("file", file)
      console.log("this.uploadedFilesthis.uploadedFiles", this.uploadedFiles)
      console.log(" this.maxSize", this.maxSize)
      console.log("file.size", file.size)
      console.log("file.type", file.type)

      if (file.type != "image/png" && file.type != "image/jpeg" && file.type != "image/jpg" && file.type != "application/pdf") {
        this.showToast("error", "png, jpeg, jpg, PDF files only allowed");
        event.srcElement.value = null;
        return;
      }

      if (file.size > this.maxSize) {
        this.showToast("error", "File exceeds 2MB");
        event.srcElement.value = null;
        return;
      }
      if (this.uploadedFiles && i < this.uploadedFiles.length) {
        console.log(" this.uploadedFiles.length", this.uploadedFiles.length,)
        this.uploadedFiles[i] = file;
      } else if (this.uploadedFiles) {
        console.log("this.uploadedFiles else if ", this.uploadedFiles)
        this.uploadedFiles.push(file);
      } else {
        console.log("[file]", [file],)
        this.uploadedFiles = [file];
      }

      const reader = new FileReader();
      console.log("reader", reader)
      reader.readAsDataURL(file);
      console.log("file", file)
      reader.onload = (event) => {
        let previewUrl = reader.result;
        //console.log("previewUrl", previewUrl)
        this.documents.at(i).patchValue({

          name: file.name,
          type: file.type,
          previewUrl: previewUrl,
        });
        console.log(" this.documents end", this.documents)
      };
    }
    else {

      this.documents.at(i).patchValue({ name: '', type: '', previewUrl: '' });
    }
  }

  public addingDocument(i: number): void {
    if (this.documents && this.documents.length >= 10) {
      this.showToast("error", "Maximum 10 documents can be uploaded");
      return;
    }
    this.documents = this.forms.documentsForm.get(
      "documents"
    ) as UntypedFormArray;
    this.documents.push(this.createDocument());
  }
  /** removing current speciality form list */
  public removingCurrentDocument(i: number): void {
    if (this.documents.length === 1) {
      this.inputFile.nativeElement.value = "";
      this.documents.reset();
    }
    else if (this.details.documents.length + 1 === this.documents.length) {
      this.documents.removeAt(i);
      this.addingDocument(i);
    }
    else {
      this.documents.removeAt(i);
      if (this.uploadedFiles) this.uploadedFiles.splice(i, 1);
    }
  }

  createDocument(
    description = "",
    name = "",
    type = "",
    previewUrl = "",
    readOnly = false
  ): UntypedFormGroup {
    return this._formBuilder.group({
      description: [description, [Validators.required]],
      name: [name, [Validators.required]],
      type: [type],
      previewUrl: [previewUrl],
      readOnly: [readOnly],
    });
  }

  previewDocument(i) {
    if (
      this.documents.at(i).value &&
      this.documents.at(i).value.previewUrl &&
      this.documents.at(i).value.previewUrl.length > 0
    ) {
      if (
        this.documents.at(i).value.type &&
        this.documents.at(i).value.type.length > 0 &&
        this.documents.at(i).value.type.includes("/")
      ) {
        let file = this.documents.at(i).value.type.split("/");
        if (file && file.length > 0) {
          let fileType = file[0];
          if (Utils.IMGFILE == fileType) {
            Swal.fire({
              imageUrl: this.documents.at(i).value.previewUrl,
              showConfirmButton: false,
              showCloseButton: true,
            });
          } else {
            this.pdfSrc = this.documents.at(i).value.previewUrl;
            this.modal.open(this.PDFModal, {
              size: "lg",
              centered: true,
              backdrop: "static",
            });
          }
        }
      }
    }
  }

  // public resetForm(i){
  //   console.log(this.documents);
  //   if(this.documents.value.length > 0){
  //     this.documents.removeAt(i);
  //     if (this.uploadedFiles) this.uploadedFiles.splice(i, 1);
  //   }
  //   if(this.documents.length === 0){
  //     this.documents.reset();
  //     this.documents.updateValueAndValidity();
  //     console.log(this.documents);
  //   }

  // }

  saveDocuments() {
    if (this.forms.documentsForm.valid) {
      Swal.fire({
        title: "On final submit, the documents cannot be removed",
        text: "Are you sure?",
        type: "info",
        showCancelButton: true,
        buttonsStyling: true,
        confirmButtonClass: "btn btn-primary",
        confirmButtonText: "Yes",
        cancelButtonClass: "btn btn-secondary",
      }).then((result) => {
        if (result.value) {
          if (this.documents.value.length > 0) {
            let docs = [];
            this.documents.value.forEach((doc) => {
              console.log("doc", doc)
              if (!doc.readOnly) {
                console.log("doc.readOnly", doc.readOnly)
                delete doc.previewUrl;
                delete doc.readOnly;
                docs.push(doc);
                console.log("docs", docs)
              }
            });
            // get signed url from backend to upload
            this.spinner.show();
            this.service
              .uploadDocs(
                {
                  pid: this.details.pid,
                  aid: this.details.aid,
                  documents: docs,
                },
                this.uploadedFiles
              )
              .subscribe(
                (res) => {
                  this.spinner.hide();
                  this.showToast("success", "Documents uploaded !");
                  window.location.reload();
                },
                (error) => {
                  this.spinner.hide();
                  this.showToast(
                    "error",
                    "Error in uploading documents. Please try again !"
                  );
                }
              );
          }
        }
      });
    }
  }

  formValidation(i, key, arrayName) {
    let error = false;
    console.log(" i, key, arrayName", i, key, arrayName);
    // console.log("this.doctorCurrentTab", this.doctorCurrentTab);


    if (

      this.forms.documentsForm.get([arrayName]).controls[i] &&
      this.forms.documentsForm.get([arrayName]).controls[i].controls[key] &&
      this.forms.documentsForm.get([arrayName]).controls[i].controls[key].errors
    ) {
      error = true;
    }
    console.log("e", error);
    return error;
  }

  closeModal() {
    this.modal.dismissAll();
  }



  isDateDisabled = (date: NgbDateStruct) => {
    // Check if the input date matches any date in noSlotDate array
    const isDisabledDate = this.noSlotDate.some((disableDate: { date: string | number | Date; }) => {
      return (
        date.year === new Date(disableDate.date).getFullYear() &&
        date.month === new Date(disableDate.date).getMonth() + 1 &&
        date.day === new Date(disableDate.date).getDate()
      );
    });
    // Check if the date falls on a weekend
    const isWeekend = this.disableWeekends(date);
    // Return true if either condition is met (date is disabled or it's a weekend)
    return isDisabledDate || isWeekend;
  };
  disableWeekends = (date: NgbDateStruct) => {
    const day = new Date(date.year, date.month - 1, date.day).getDay();
    return this.excludeDays.includes(day);
  }


  getAllTimeSlots() {
    this.spinner.show();
    console.log("currentDate", this.currentDate)
    this.service
      .getallappoint({
        drid: this.physician.u_id,
        cur_date: `${this.currentDate.year}-${this.currentDate.month}-${this.currentDate.day}`,
        days: `30`,
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.allTimeSlots = res;
          console.log("this.allTimeSlots", this.allTimeSlots)

          // Split the array based on slotCount === 0
          const splitData = this.allTimeSlots.reduce((acc, obj) => {
            if (obj.slotCount === 0) {
              acc.zero.push(obj);
            } else {
              acc.nonZero.push(obj);
            }
            return acc;
          }, { zero: [], nonZero: [] });
          this.noSlotDate = splitData.zero
          console.log("splitData.zero", splitData.zero); // Array of objects with slotCount === 0
          console.log("splitData.nonZero", splitData.nonZero);
        },
        (error) => {
          this.spinner.hide();
          this.showToast(
            "error",
            "Something went wrong while fetching time slots. Please try again."
          );
        }
      );
  }

  getDayName = {
    '0': 'Sun',
    '1': 'Mon',
    '2': 'Tue',
    '3': 'Wed',
    '4': 'Thu',
    '5': 'Fri',
    '6': 'Sat'
  }
  getDefaultWorkingHours(dr_id) {
    let drid = dr_id;
    this.spinner.show();
    this.service.getWorkingHours(drid).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res.length > 0) {
          this.workingHours = res;
          //console.log("this.workingHours", this.workingHours)
          this.excludeDays = [];
          this.workingHours.map(x => {
            x.dayName = this.getDayName[x.day];
            x.start_time = x.start_time.split(':');
            x.start_time = { hour: parseInt(x.start_time[0]), minute: parseInt(x.start_time[1]) };
            x.end_time = x.end_time.split(':');
            x.end_time = { hour: parseInt(x.end_time[0]), minute: parseInt(x.end_time[1]) };
            if (x.start_time.hour === x.end_time.hour && x.start_time.minute === x.end_time.minute) {
              x.Checked = true;
            } else {
              x.Checked = false;
            }
          });
        }
        this.excludeDays = this.workingHours.filter(day => day.Checked).map(day => day.day);

        console.log("getWorkingHours", this.workingHours);
        console.log("excludeDays", this.excludeDays);


      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
  }

  getPhysician() {
    this.spinner.show();
    this.service
      .getPhysicianById(
        this.route.snapshot.queryParams["drid"],
        // this.route.snapshot.params["aptid"],
        "?verified=true "
      )
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.loading = false;
          this.physician = res;


          console.log("this.physician this.physician", this.physician)
          let interval_apt = this.physician?.aptinterval ?? 0
          this.today = new Date(); // Sets today's date
          this.nextDay = new Date(this.today);
          this.nextDay.setDate(this.today.getDate() + interval_apt);
          const dateObject = new Date(this.nextDay);
          const year = dateObject.getFullYear();
          const month = dateObject.getMonth() + 1; // Months are zero-indexed, so adding 1
          const day = dateObject.getDate();
          this.aptinterval = {
            year: year,
            month: month,
            day: day,
          };
          console.log("this.aptinterval", this.aptinterval)
          this.getDefaultWorkingHours(this.physician.u_id);
          // this.checkPatientData();
          // this.setPhysicianDetail();
          this.getAllTimeSlots();
        },
        (error) => {
          this.spinner.hide();
          this.loading = false;
          let msg =
            error && error.error && error.error.message
              ? error.error.message
              : "Something went wrong. Please try again.";
          this.showToast("error", msg);
        }
      );
  }
}
